export const FEATURE_NAME = 'HybridWrapper' as const;
export const LOG_PREFIX = 'Hybrid Wrapper:' as const;
